import { AppServices, Misc, Numeric, Validation } from '@singularsystems/neo-core';
import Types from './AppTypes';
import Axios from 'axios';
import { AuthorisationTypes, Settings as AuthSettings } from '@singularsystems/neo-authorisation';
import { ReportingTypes } from '@singularsystems/neo-reporting';
import { NotificationServiceTypes } from '@singularsystems/neo-notifications';
import { AppConfig } from './Models/AppConfig';
import { OidcAuthService } from './Services/AuthenticationService';
import { RouteService } from './Services/RouteService';
import { RouteSecurityService } from './Services/RouteSecurityService';
import AppLayout from './Services/AppLayout';
import AsyncSelect from 'react-select/async'
import Select from 'react-select';
import { NeoServicesTypes } from '@singularsystems/neo-react-services';
import Decimal from "decimal.js-light";

const AppModule = new AppServices.Module("App", container => {

    // Config
    container.bind(Types.App.Config).to(AppConfig).inSingletonScope();
    container.bindConfig(AuthorisationTypes.ConfigModel, (c: AppConfig) => c.authorisationConfig);
    container.bindConfig(NotificationServiceTypes.ConfigModel, (c: AppConfig) => c.notificationServerConfig);
    container.bindConfig(ReportingTypes.ConfigModel, (c: AppConfig) => c.reportingConfig);
    container.bindConfig(NeoServicesTypes.IntegrityChecking.ConfigModel, (c: AppConfig) => c.integrityCheckingConfig);

    // Security
    container.bind(Types.Neo.Security.AuthenticationService).to(OidcAuthService).inSingletonScope();

    // Api clients
    container.bind(Types.Neo.Axios).toConstantValue(Axios);

    // Services
    container.bind(Types.App.Services.AppLayout).to(AppLayout).inSingletonScope();
    container.bind(Types.App.Services.RouteService).to(RouteService).inSingletonScope();
    container.bind(Types.Neo.Routing.RouteSecurityService).to(RouteSecurityService).inSingletonScope();

    // Components
    container.bind(Types.Neo.Components.AsyncSelect).toConstantValue(AsyncSelect);
    container.bind(Types.Neo.Components.ReactSelect).toConstantValue(Select);
    container.bind(Types.Neo.Core.DecimalService).toConstantValue(new Numeric.DecimalService(Decimal, Decimal.ROUND_HALF_UP, Decimal.ROUND_DOWN));

    Misc.Settings.bootstrap.version = 5.3;
    Misc.Settings.grid.deleteButton.size = "sm";
    Misc.Settings.grid.editButton.size = "sm";
    Misc.Settings.grid.useStickyHeaders = true;
    Misc.Settings.grid.borderType = "standard";
    Misc.Settings.fixedAppHeaderElement = () => document.querySelector(".app-header-panel");
    Misc.Settings.form.validationDisplayMode = Validation.DisplayMode.Always;
    Misc.Settings.list.removeItemBehavior = Misc.RemoveItemBehavior.MarkDeleted;
    Misc.Settings.buttons.backButton.variant = "light";
    Misc.Settings.buttons.backButton.isOutline = false;

    AuthSettings.roles.showInlineDescriptions = true;
});

const AppTestModule = new AppServices.Module("App", container => {

});

export { AppModule, AppTestModule };